import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateUsersPipe } from './translate-users.pipe';



@NgModule({
  declarations: [
    TranslateUsersPipe
  ],
  exports: [
    TranslateUsersPipe
  ],
  imports: [
    CommonModule
  ]
})
export class TranslateUsersModule { }
